import { Component } from '@angular/core';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';
import { MatDialogRef } from '@angular/material/dialog';
import { Period } from 'src/app/assabil-kernel/models/entities/control-tables/period';


@Component({
  selector: 'period-lov',
  templateUrl: './period-lov.component.html',
  styleUrls: ['./period-lov.component.scss']
})


export class PeriodLovComponent extends GenericLovComponent   {

   code         : string; 
   name         : string; 

   periods: Period[] = [];

    columns = [
        {  prop: 'periodCode',      name: 'Code'},
        {  prop: 'name',            name: 'Nom'}
    ]


//----------------------------------------------------------------------
constructor( 
    public dialogRef: MatDialogRef<PeriodLovComponent>,
    protected controlTablesService  : ControlTablesService) {
    super();
    this.entityName = "period";
}
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.periods = result;
    })
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
closeModal(row : Period){
    this.dialogRef.close(row);
}
//----------------------------------------------------------------------

}
